import { theme } from "../../../../utils";

export const desktopNavStyles = {
    navBarWrapper: {
        flex: 1,
        height: "53px",
        display: "flex",
        alignItems: 'flex-end',
        justifyContent: "center",
        paddingBottom: "0px",
        position: "absolute",
        top: '31px',
        left: '150px',
        right: 0,
        bottom: 0
    },
    navLink : (isActive: boolean) => ({
        ...theme.typography.poppinsBodyBold,
        fontSize: "20px",
        marginRight: "10px",
        paddingLeft: "20px",

        color: isActive ? "black" : "grey",
        fontWeight: isActive ? "800" : "400",

        textDecoration: isActive ? "underline" : "none",
        textDecorationColor: isActive
            ? theme.palette.primary.main
            : "transparent",
        textDecorationThickness: isActive ? "3px" : "0",
        textUnderlineOffset: "14px",
    }),


}
